import axios from 'axios'

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

const BASE_CLASS_GROUP_URL = `${BASE_URL}api/classGroups`;
const BASE_CLASS_URL = `${BASE_URL}api/classes`;
const BASE_TRADE_TYPES_URL = `${BASE_URL}api/tradeTypes`;

const ClassService = () => ({

    getClassGroups: async () => {
        const { data } = await axios.get(`${BASE_CLASS_GROUP_URL}`);
        return data;
    },

    getTradeTypes: async () => {
        const { data } = await axios.get(`${BASE_TRADE_TYPES_URL}`);
        return data;
    },

    editClass: async (classId, displayLabel, classGroupId, tradeType, passData, passInfo) => {
        const { status } = await axios.put(`${BASE_CLASS_URL}/${classId}`, { classGroupId, displayLabel, tradeType, passData, passInfo });
        return status;
    },

    enableClass: async (courseId, classId) => {
        const { status } = await axios.put(`${BASE_CLASS_URL}/${classId}/enable`);
        return status;
    },

    disableClass: async (courseId, classId) => {
        const { status } = await axios.put(`${BASE_CLASS_URL}/${classId}/disable`);
        return status;
    },

    refreshClass: async (providerId, classId) => {
        const { status, data } = await axios.get(`${BASE_CLASS_URL}/${providerId}/${classId}/refresh`)
        return data;
    }
});

export default ClassService;